import { render } from "./BlockUI.vue?vue&type=template&id=bcbd5cfa"
import script from "./BlockUI.vue?vue&type=script&lang=js"
export * from "./BlockUI.vue?vue&type=script&lang=js"

import "./BlockUI.vue?vue&type=style&index=0&id=bcbd5cfa&lang=css"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\32\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__